export default __webpack_public_path__ + "static/media/icon_3rd-party-download.a56e6e86.svg";